<template>
    <div class="container remove-padding-margin">
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1">
                    <div class="text-alignC mar-top-144"><img src="../../assets/icons/ic_baseline-email.svg" alt=""></div>
                    <div class="font-16 font-weight-600 color-0000 line-height-25 letter-space-002 text-center mar-top-40">Link Verifikasi Terkirim</div>
                    <div class="color-8080 text-center letter-space-002 line-height-21 font-14">Link verifikasi telah dikirim ke <span class="color-0000"><b>{{email_owner}}</b></span>, silakan verifikasi email baru Anda. Link hanya aktif selama 15 menit.</div>
                </div>
                <div>
                    <div class="button-lanjut">
                        <button class="btn btn-login btn-long" id="btnsuccess" @click="godetailakun">
                            <span id="textbtnsuccess">Oke</span>
                        </button>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    export default {
        name: "SuccessChangeEmail",
        data(){
            return{
                owner:'',
                email_owner:'',
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        mounted(){
            this.getdetailowner()
        },
        methods:{
            godetailakun(){
                this.$router.push('/loginowneremail')
            },
            async getdetailowner() {
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').show();
                this.isClickedloader = true
                try {
                    var telp = localStorage.getItem("telp");
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/data_detail_owner',  this.requestHeaders);
                    this.owner = res.data.data
                    if(res.data.status===true){
                        $('#loadingPage').removeClass('overlayLoading');
                        this.isClickedloader = false;
                        // $('#loadingPage').hide();
                        var dataowner = res.data.data
                        this.email_owner = this.$route.params.email
                    }else{

                    }
                } catch (e) {
                    if (!e.code) {
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false
                        $('#alert').show()
                        $('#contentAlert').text("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti");
                        $('#alert').removeClass("alert alert-danger animated fadeOutUp");
                        $('#alert').addClass("alert alert-danger animated fadeInDown");
                        $('#close').show()
                        setTimeout(() => {
                            $('#alert').removeClass("alert alert-danger animated fadeInDown");
                            $('#alert').addClass("alert alert-danger animated fadeOutUp");
                        }, 30000)
                        this.isClickedloader = false
                        $('#textBtnpersonal').show()
                        $('#btnpersonal').prop('disabled', false);
                    }
                    else if (e.response.status === 500) {
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false
                        $('#alert').show()
                        $('#contentAlert').text(e.response.data.msg);
                        $('#alert').removeClass("alert alert-danger animated fadeOutUp");
                        $('#alert').addClass("alert alert-danger animated fadeInDown");
                        $('#close').show()
                        this.isClicked = false
                        $('#textBtnpersonal').show()
                        $('#btnpersonal').prop('disabled', false);
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>